import 'css-chunksrc/client/scenes/strategicAxisCreation/form/colorPickerInput/styles.scss';export default {
  "form": "_form_k9eoi_1",
  "iconBox": "_iconBox_k9eoi_21",
  "icon": "_icon_k9eoi_21",
  "group": "_group_k9eoi_36",
  "input": "_input_k9eoi_40",
  "colorPicker": "_colorPicker_k9eoi_51"
};